__turbopack_context__.v({
  "container": "card-list-module__r1D8ba__container",
  "fluid": "card-list-module__r1D8ba__fluid",
  "item": "card-list-module__r1D8ba__item",
  "label": "card-list-module__r1D8ba__label",
  "linkCard": "card-list-module__r1D8ba__linkCard",
  "nav": "card-list-module__r1D8ba__nav",
  "navButton": "card-list-module__r1D8ba__navButton",
  "picture": "card-list-module__r1D8ba__picture",
  "pictures": "card-list-module__r1D8ba__pictures",
  "wrapper": "card-list-module__r1D8ba__wrapper",
});
